// extracted by mini-css-extract-plugin
export default {"container":"UploadModal_container__IT758","upload":"UploadModal_upload__pVL1B","dropContainer":"UploadModal_dropContainer__TDEnc"};